import _asyncToGenerator from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["Component", "pageProps"];
import _regeneratorRuntime from "/root/code/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React from "react";
import merge from "lodash-es/merge";
import dynamic from "next/dynamic";
import { CART_APOLLO_CACHE_CONFIG } from "@catchoftheday/cart-components";
import { PageContainer } from "@catchoftheday/cg-components";
import { CMS_CONFIG_APOLLO_CACHE_CONFIG, nextAppHOC } from "@catchoftheday/common-vendors";
import { getEnvConfig, withEnvConfig } from "@catchoftheday/env-config";
import { ONEPASS_SHOP_APOLLO_CACHE_CONFIG } from "@catchoftheday/onepass";
import { ThemeProvider } from "@catchoftheday/theme";
import { jsx as ___EmotionJSX } from "@emotion/react";
var DynamicLoadMock = dynamic(function () {
  return import("../mocks/index");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../mocks/index")];
    }
  }
});

function CustomApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(ThemeProvider, null, ___EmotionJSX(PageContainer, null, false && // eslint-disable-next-line n/no-process-env
  process.env.NEXT_PUBLIC_USE_MOCK === "true" && ___EmotionJSX(DynamicLoadMock, null), ___EmotionJSX(Component, _extends({}, pageProps, rest))));
}

CustomApp.getInitialProps = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", {});

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));
export default withEnvConfig(nextAppHOC({
  graphqlEndpoint: function graphqlEndpoint() {
    return getEnvConfig().GRAPHQL_ENDPOINT;
  },
  apolloCacheConfig: merge(CMS_CONFIG_APOLLO_CACHE_CONFIG, CART_APOLLO_CACHE_CONFIG, ONEPASS_SHOP_APOLLO_CACHE_CONFIG),
  // eslint-disable-next-line n/no-process-env
  connectToDevTools: false,
  fonts: ["biennale", "montserrat"],
  seo: {
    canonicalTag: {
      useTrailingSlash: function useTrailingSlash(_ref3) {
        var url = _ref3.url;
        return url.pathname.indexOf("shop/onepass") >= 0;
      }
    },
    alternateTags: {
      useTrailingSlash: function useTrailingSlash(_ref4) {
        var url = _ref4.url;
        return url.pathname.indexOf("shop/onepass") >= 0;
      }
    }
  },
  isProxiedThroughCotdWeb: true
})(CustomApp));